import { cloneDeep } from "lodash";
import {
  updateStateAfterWidgetOptionChange,
  isMdaeWidgetOptionChangeEvent,
} from "../../../mdae-framework";
import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { GET_CLIENT_LOGO } from "../services/get-client-logo";

export const TOGGLE_USER_ACTION_POPOVER = "TOGGLE_USER_ACTION_POPOVER";
export const TOGGLE_HELP_ACTION_POPOVER = "TOGGLE_HELP_ACTION_POPOVER";

const initialState = {
  companyLogo: "",
  isCompanyLogoLoded: false,
};

export default function (state = initialState, action) {
  let newState;
  switch (action.type) {
    case TOGGLE_USER_ACTION_POPOVER:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case TOGGLE_HELP_ACTION_POPOVER:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_CLIENT_LOGO)(action)) {
        return { ...state, companyLogo: "", isCompanyLogoLoded: false };
      }
      if (isAsyncComplete(GET_CLIENT_LOGO)(action)) {
        return {
          ...state,
          companyLogo: action.response.companyLogo,
          isCompanyLogoLoded: true,
        };
      }
      return state;
    default:
      return state;
  }
}
